export default __webpack_public_path__ + "950ad40d8a1e9400268cf55d535f4ac2.webp";